<template lang="html">
  <div class="group-container">
    <div class="group-item" v-for="(item, index) in items">
      <div class="count-down">
        <span class="end">距离活动结束：</span>
        <span class="countDown-content">
          仅剩<countDown
            :targetTime="changeTimeFormat(item.endTime)"
            :timeOffset="timeOffset(item.systemTime)"
            :isIOS="isIOS"
          ></countDown>
        </span>
      </div>
      <div class="item-box">
        <div
          class="item-img"
          :style="{ backgroundImage: 'url(' + item.coverPic + ')' }"
        ></div>
        <div class="item-conent">
          <span class="title limit">{{ item.skuName }}</span>
          <p class="desc limit">{{ item.groupName }}</p>
          <p class="shop-info">
            <i class="shop-icon"></i
            ><span class="shop-info-content limit">{{
              item.businessName
            }}</span>
          </p>
        </div>
      </div>
      <div class="price-part">
        <div class="price-detail">
          <p class="group-price">
            <i class="icon">&yen;</i
            ><span class="price">{{ item.groupPrice / 100 }}</span>
          </p>
          <div class="member" :class="{ 'fix-text': !isIOS }">
            {{ item.groupLimitNum }}人团
          </div>
          <p class="pre-price">
            单买价 <span>&yen;{{ item.presentPrice / 100 }}</span>
          </p>
        </div>
        <button class="join-button" @click="joinGroup(item)">去参团</button>
      </div>
    </div>
  </div>
</template>

<script>
import countDown from '@/components/common/countDown'
import isIOS from '@/plugins/isIOS'

export default {
  components: {
    countDown
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isIOS: false
    }
  },
  methods: {
    // 跳转团详情页 参团
    joinGroup(item) {
      const { spuId, skuId, groupRuleId } = item
      const params = location.search.replace(/^\?/, '').split('&')
      let hserecomkey
      params.forEach(p => {
        const res = p.split('=')
        if (res[0] === 'hserecomkey') {
          hserecomkey = res[1]
        }
      })
      location.href = `/v/groupBuy/groupInfo/${spuId}?skuId=${skuId}&ruleId=${groupRuleId}&hserecomkey=${hserecomkey}&ruleType=4&refresh=no`
    },
    changeTimeFormat(date) {
      return new Date(date).getTime()
    },
    timeOffset(date) {
      return date - Date.now()
    }
  },
  created() {
    this.isIOS = isIOS
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.group-container {
  margin-bottom: rem(20px);
}
.group-item {
  width: rem(710px);
  margin: rem(20px) rem(20px) 0 rem(20px);
  padding: rem(30px) rem(30px) rem(24px);
  background: #fff;
  border-radius: rem(8px);

  .item-box {
    display: flex;
    border-bottom: rem(1px) solid #f0f0f0;

    .item-img {
      width: rem(200px);
      height: rem(120px);
      position: relative;
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: cover;
      flex-shrink: 0;
    }

    .item-conent {
      margin-left: rem(20px);
      margin-bottom: rem(20px);
      flex: 1;

      .title {
        font-size: rem(30px);
        color: #121212;
        font-weight: bold;
        line-height: rem(40px);
        max-width: rem(420px);
        display: block;
      }

      .desc {
        font-size: rem(26px);
        color: #666666;
        line-height: rem(32px);
        margin-top: rem(8px);
        max-width: rem(420px);
      }
      .shop-info {
        display: flex;
        align-items: center;
        margin-top: rem(8px);
        .shop-icon {
          display: inline-block;
          margin-right: rem(10px);
          width: rem(24px);
          height: rem(24px);
          box-sizing: border-box;
          background: url('//cmspic-10004025.image.myqcloud.com/086d4a90-225b-11ea-a5e7-dbd8a7023663_size_36x36')
            no-repeat center center;
          background-size: contain;
          flex-shrink: 0;
        }
        .shop-info-content {
          font-size: rem(24px);
          color: #999999;
          line-height: rem(32px);
          display: block;
          max-width: rem(380px);
        }
      }
    }
  }
  .price-part {
    margin-top: rem(20px);
    display: flex;
    justify-content: space-between;

    .price-detail {
      display: flex;
      align-items: center;
      .group-price {
        color: #ff397e;
        font-size: rem(24px);
        padding-top: rem(2px);
        .icon {
          line-height: rem(24px);
        }
        .price {
          font-size: rem(36px);
          line-height: rem(32px);
        }
      }
      .member {
        line-height: rem(20px);
        margin-right: rem(10px);
        color: #ff397e;
        font-size: rem(20px);
        padding: rem(6px) rem(8px) rem(2px);
        border: 1px solid #ff397e;
        border-radius: rem(30px);
        margin-left: rem(8px);
        &.fix-text {
          padding: rem(6px) rem(8px) rem(2px);
        }
      }
      .pre-price {
        font-size: rem(22px);
        color: #999999;
        line-height: rem(30px);

        span {
          text-decoration: line-through;
        }
      }
    }

    .join-button {
      width: rem(140px);
      height: rem(60px);
      background-image: linear-gradient(90deg, #ff79a8 0%, #ff5390 100%);
      box-shadow: 0 rem(4px) rem(10px) 0 #ffbed5;
      border-radius: rem(50px);
      color: #fff;
      font-size: rem(28px);
      line-height: rem(61px);
    }
  }

  .count-down {
    margin-bottom: rem(20px);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .end {
      font-size: rem(24px);
      color: #666;
    }

    .countDown-content {
      font-size: rem(24px);
      color: #121212;
      display: flex;
      align-items: center;
      margin-left: rem(30px);
      .countdown {
        margin-left: rem(10px);
      }
    }
  }
}
.limit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
